import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../../../components/Loader.jsx";
import { PAAM_RATINGS_URL } from "../../../../constants/platformRatings.js";
import PlatformRatingsIframe from "./PlatformRatingsIframe.jsx";

const PaamRatings = () => {
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.user);
  const canView = Boolean(userDetails?.isPammEnable);

  useEffect(() => {
    if (userDetails?._id && !canView) {
      navigate("/dashboard", { replace: true });
    }
  }, [userDetails?._id, canView, navigate]);

  if (!userDetails?._id) return <Loader />;
  if (!canView) return null;

  return (
    <PlatformRatingsIframe src={PAAM_RATINGS_URL} iframeTitle="PAAM ratings" />
  );
};

export default PaamRatings;
